// SplitRow.tsx
import React from 'react';

interface SplitRowProps {
  currentText: string;
  multiline?:  boolean;
  children:    React.ReactNode;
}

const SplitRow: React.FC<SplitRowProps> = ({ currentText, multiline, children }) => (
  <div className={`cse-split-row${multiline ? ' cse-split-row--multiline' : ''}`}>
    <div className="cse-split-accent" />
    <div className="cse-split-body">
      <span className="cse-split-current-text">{currentText}</span>
      <div className={`cse-split-input-slot${multiline ? ' cse-split-input-slot--textarea' : ''}`}>
        {children}
      </div>
    </div>
  </div>
);

export default SplitRow;